import { request } from "./http";

function asArray(value) {
  return Array.isArray(value) ? value : [];
}

function asObject(value) {
  return value && typeof value === "object" ? value : {};
}

function toNumber(value, fallback = 0) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function normalizeItem(raw = {}) {
  const item = asObject(raw);
  return {
    financeEntryId: item.financeEntryId ?? item.finance_entry_id ?? null,
    bookingId: item.bookingId ?? item.booking_id ?? null,
    bookingMemberId: item.bookingMemberId ?? item.booking_member_id ?? null,
    clientUserId: item.clientUserId ?? item.client_user_id ?? null,
    bookingType: String(item.bookingType || item.booking_type || "").toUpperCase(),
    sessionTitle: String(item.sessionTitle || item.session_title || ""),
    sessionStatus: String(item.sessionStatus || item.session_status || "").toUpperCase(),
    startAt: item.startAt || item.start_at || null,
    endAt: item.endAt || item.end_at || null,
    clientName: String(item.clientName || item.client_name || ""),
    clientAvatarUrl: String(item.clientAvatarUrl || item.client_avatar_url || ""),
    amountDue: toNumber(item.amountDue ?? item.amount_due, 0),
    amountPaid: toNumber(item.amountPaid ?? item.amount_paid, 0),
    paymentStatus: String(item.paymentStatus || item.payment_status || "UNPAID").toUpperCase(),
    paymentMethod: String(item.paymentMethod || item.payment_method || ""),
    paymentDate: item.paymentDate || item.payment_date || null,
    clientMarkedPaidAt: item.clientMarkedPaidAt || item.client_marked_paid_at || null,
    paymentConfirmedAt: item.paymentConfirmedAt || item.payment_confirmed_at || null,
    comment: String(item.comment || item.paymentComment || item.payment_comment || ""),
    paymentTermsSnapshot: String(item.paymentTermsSnapshot || item.payment_terms_snapshot || ""),
    needsAction: Boolean(item.needsAction ?? item.needs_action),
  };
}

function unwrapItem(payload) {
  const raw = asObject(payload);
  return normalizeItem(raw.item ?? raw.data ?? raw);
}

export const financeApi = {
  async listMine() {
    const payload = await request("/api/me/finance/bookings", { method: "GET" });
    return asArray(payload?.items ?? payload?.content ?? payload).map(normalizeItem);
  },

  async updateBooking(bookingId, data = {}) {
    if (!bookingId) throw new Error("bookingId is required");
    const payload = await request(`/api/me/finance/bookings/${encodeURIComponent(String(bookingId))}`, {
      method: "PUT",
      json: data,
    });
    return unwrapItem(payload);
  },
};
